const AppFooter = () => {

  return <div>
    <p className="f-11">Copyright 2025 Integrated Database Systems, Inc.|web10 <span className="text-success">(Privacy policy)</span></p>
  </div>
}

export default AppFooter
